import { HttpEvent, HttpHandler, HttpInterceptor, HttpRequest } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { Observable } from 'rxjs';

import { SessionService } from '../../../auth/session.service';

@Injectable()
export class SessionTokenInterceptor implements HttpInterceptor {
  private sessionService = inject(SessionService);

  public intercept<T>(request: HttpRequest<T>, next: HttpHandler): Observable<HttpEvent<T>> {
    if (this.sessionService.token) {
      return next.handle(
        request.clone({
          setHeaders: {
            Authorization: `Bearer ${this.sessionService.token}`,
          },
        }),
      );
    }

    return next.handle(request);
  }
}
